import { motion } from "framer-motion";

export default function AlumniShowcase() {
  const alumni = [
    {
      name: "Sarah Ahmed",
      batch: "BBA, 2015",
      role: "Marketing Manager, Unilever",
      image: "https://randomuser.me/api/portraits/women/44.jpg",
    },
    {
      name: "Rafiq Hasan",
      batch: "CSE, 2016",
      role: "Software Engineer, Google",
      image: "https://randomuser.me/api/portraits/men/32.jpg",
    },
    {
      name: "Ayesha Rahman",
      batch: "Pharmacy, 2017",
      role: "Research Scientist, Pfizer",
      image: "https://randomuser.me/api/portraits/women/50.jpg",
    },
    {
      name: "Tanvir Alam",
      batch: "BBA, 2014",
      role: "Entrepreneur, Startup Founder",
      image: "https://randomuser.me/api/portraits/men/45.jpg",
    },
    {
      name: "Nusrat Jahan",
      batch: "LLB, 2018",
      role: "Legal Consultant, World Bank",
      image: "https://randomuser.me/api/portraits/women/65.jpg",
    },
    {
      name: "Hasibul Karim",
      batch: "CSE, 2019",
      role: "Data Scientist, Amazon",
      image: "https://randomuser.me/api/portraits/men/60.jpg",
    },
    {
      name: "Maria Chowdhury",
      batch: "Economics, 2013",
      role: "Policy Analyst, UNDP",
      image: "https://randomuser.me/api/portraits/women/38.jpg",
    },
    {
      name: "Kamal Hossain",
      batch: "EEE, 2012",
      role: "Project Engineer, Siemens",
      image: "https://randomuser.me/api/portraits/men/70.jpg",
    },
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4"
          >
            Meet Our Alumni
          </motion.h2>

          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="text-gray-600 max-w-2xl mx-auto"
          >
            Discover the inspiring journeys of our alumni across different
            industries and roles.
          </motion.p>
        </div>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
          {alumni.map((person, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-white rounded-2xl shadow-md hover:shadow-xl transition p-6 text-center"
            >
              <img
                src={person.image}
                alt={person.name}
                className="w-24 h-24 mx-auto rounded-full mb-4 object-cover border-4 border-gray-100"
              />
              <h3 className="text-lg font-semibold text-gray-900">
                {person.name}
              </h3>
              <p className="text-sm text-gray-500">{person.batch}</p>
              <p className="text-sm text-gray-700 mt-2">{person.role}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
